import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import SamGuide from '~root/src/components/SamGuide/SamGuide.vue?shadow'
window.customElements.define('samora-sam-guide', wrap(Vue, SamGuide))

import SamAccordion from '~root/src/components/SectionComponents/SamAccordion/SamAccordion.vue?shadow'
window.customElements.define('samora-sam-accordion', wrap(Vue, SamAccordion))

import SamBadge from '~root/src/components/SectionComponents/SamBadge/SamBadge.vue?shadow'
window.customElements.define('samora-sam-badge', wrap(Vue, SamBadge))

import SamBanner from '~root/src/components/SectionComponents/SamBanner/SamBanner.vue?shadow'
window.customElements.define('samora-sam-banner', wrap(Vue, SamBanner))

import SamBreadcrumbs from '~root/src/components/SectionComponents/SamBreadcrumbs/SamBreadcrumbs.vue?shadow'
window.customElements.define('samora-sam-breadcrumbs', wrap(Vue, SamBreadcrumbs))

import SamButton from '~root/src/components/SectionComponents/SamButton/SamButton.vue?shadow'
window.customElements.define('samora-sam-button', wrap(Vue, SamButton))

import SamCalendar from '~root/src/components/SectionComponents/SamCalendar/SamCalendar.vue?shadow'
window.customElements.define('samora-sam-calendar', wrap(Vue, SamCalendar))

import SamCard from '~root/src/components/SectionComponents/SamCard/SamCard.vue?shadow'
window.customElements.define('samora-sam-card', wrap(Vue, SamCard))

import SamCheckbox from '~root/src/components/SectionComponents/SamCheckbox/SamCheckbox.vue?shadow'
window.customElements.define('samora-sam-checkbox', wrap(Vue, SamCheckbox))

import SamChip from '~root/src/components/SectionComponents/SamChip/SamChip.vue?shadow'
window.customElements.define('samora-sam-chip', wrap(Vue, SamChip))

import SamChipSelect from '~root/src/components/SectionComponents/SamChipSelect/SamChipSelect.vue?shadow'
window.customElements.define('samora-sam-chip-select', wrap(Vue, SamChipSelect))

import SamDataTable from '~root/src/components/SectionComponents/SamDataTable/SamDataTable.vue?shadow'
window.customElements.define('samora-sam-data-table', wrap(Vue, SamDataTable))

import SamDateTimeFilter from '~root/src/components/SectionComponents/SamDateTimeFilter/SamDateTimeFilter.vue?shadow'
window.customElements.define('samora-sam-date-time-filter', wrap(Vue, SamDateTimeFilter))

import SamDateTimePicker from '~root/src/components/SectionComponents/SamDateTimePicker/SamDateTimePicker.vue?shadow'
window.customElements.define('samora-sam-date-time-picker', wrap(Vue, SamDateTimePicker))

import SamEmptyState from '~root/src/components/SectionComponents/SamEmptyState/SamEmptyState.vue?shadow'
window.customElements.define('samora-sam-empty-state', wrap(Vue, SamEmptyState))

import SamFilter from '~root/src/components/SectionComponents/SamFilter/SamFilter.vue?shadow'
window.customElements.define('samora-sam-filter', wrap(Vue, SamFilter))

import SamFloatingActions from '~root/src/components/SectionComponents/SamFloatingActions/SamFloatingActions.vue?shadow'
window.customElements.define('samora-sam-floating-actions', wrap(Vue, SamFloatingActions))

import SamFormGroup from '~root/src/components/SectionComponents/SamFormGroup/SamFormGroup.vue?shadow'
window.customElements.define('samora-sam-form-group', wrap(Vue, SamFormGroup))

import SamIcon from '~root/src/components/SectionComponents/SamIcon/SamIcon.vue?shadow'
window.customElements.define('samora-sam-icon', wrap(Vue, SamIcon))

import SamIconList from '~root/src/components/SectionComponents/SamIconList/SamIconList.vue?shadow'
window.customElements.define('samora-sam-icon-list', wrap(Vue, SamIconList))

import SamIconListItem from '~root/src/components/SectionComponents/SamIconList/SamIconListItem.vue?shadow'
window.customElements.define('samora-sam-icon-list-item', wrap(Vue, SamIconListItem))

import SamImage from '~root/src/components/SectionComponents/SamImage/SamImage.vue?shadow'
window.customElements.define('samora-sam-image', wrap(Vue, SamImage))

import SamInfoBlock from '~root/src/components/SectionComponents/SamInfoBlock/SamInfoBlock.vue?shadow'
window.customElements.define('samora-sam-info-block', wrap(Vue, SamInfoBlock))

import SamInfoState from '~root/src/components/SectionComponents/SamInfoState/SamInfoState.vue?shadow'
window.customElements.define('samora-sam-info-state', wrap(Vue, SamInfoState))

import SamInput from '~root/src/components/SectionComponents/SamInput/SamInput.vue?shadow'
window.customElements.define('samora-sam-input', wrap(Vue, SamInput))

import SamInputGroup from '~root/src/components/SectionComponents/SamInputGroup/SamInputGroup.vue?shadow'
window.customElements.define('samora-sam-input-group', wrap(Vue, SamInputGroup))

import SamInteractiveLabel from '~root/src/components/SectionComponents/SamInteractiveLabel/SamInteractiveLabel.vue?shadow'
window.customElements.define('samora-sam-interactive-label', wrap(Vue, SamInteractiveLabel))

import SamLabel from '~root/src/components/SectionComponents/SamLabel/SamLabel.vue?shadow'
window.customElements.define('samora-sam-label', wrap(Vue, SamLabel))

import SamLink from '~root/src/components/SectionComponents/SamLink/SamLink.vue?shadow'
window.customElements.define('samora-sam-link', wrap(Vue, SamLink))

import SamLoader from '~root/src/components/SectionComponents/SamLoader/SamLoader.vue?shadow'
window.customElements.define('samora-sam-loader', wrap(Vue, SamLoader))

import SamMenu from '~root/src/components/SectionComponents/SamMenu/SamMenu.vue?shadow'
window.customElements.define('samora-sam-menu', wrap(Vue, SamMenu))

import SamModal from '~root/src/components/SectionComponents/SamModal/SamModal.vue?shadow'
window.customElements.define('samora-sam-modal', wrap(Vue, SamModal))

import SamModalManager from '~root/src/components/SectionComponents/SamModalManager/SamModalManager.vue?shadow'
window.customElements.define('samora-sam-modal-manager', wrap(Vue, SamModalManager))

import SamMultiChipInput from '~root/src/components/SectionComponents/SamMultiChipInput/SamMultiChipInput.vue?shadow'
window.customElements.define('samora-sam-multi-chip-input', wrap(Vue, SamMultiChipInput))

import SamMultiSelect from '~root/src/components/SectionComponents/SamMultiSelect/SamMultiSelect.vue?shadow'
window.customElements.define('samora-sam-multi-select', wrap(Vue, SamMultiSelect))

import SamNumberPicker from '~root/src/components/SectionComponents/SamNumberPicker/SamNumberPicker.vue?shadow'
window.customElements.define('samora-sam-number-picker', wrap(Vue, SamNumberPicker))

import SamPagination from '~root/src/components/SectionComponents/SamPagination/SamPagination.vue?shadow'
window.customElements.define('samora-sam-pagination', wrap(Vue, SamPagination))

import SamProgressIndicator from '~root/src/components/SectionComponents/SamProgressIndicator/SamProgressIndicator.vue?shadow'
window.customElements.define('samora-sam-progress-indicator', wrap(Vue, SamProgressIndicator))

import SamRadioGroup from '~root/src/components/SectionComponents/SamRadioGroup/SamRadioGroup.vue?shadow'
window.customElements.define('samora-sam-radio-group', wrap(Vue, SamRadioGroup))

import SamSearch from '~root/src/components/SectionComponents/SamSearch/SamSearch.vue?shadow'
window.customElements.define('samora-sam-search', wrap(Vue, SamSearch))

import SamSectionHeader from '~root/src/components/SectionComponents/SamSectionHeader/SamSectionHeader.vue?shadow'
window.customElements.define('samora-sam-section-header', wrap(Vue, SamSectionHeader))

import SamSelect from '~root/src/components/SectionComponents/SamSelect/SamSelect.vue?shadow'
window.customElements.define('samora-sam-select', wrap(Vue, SamSelect))

import SamSelectList from '~root/src/components/SectionComponents/SamSelectList/SamSelectList.vue?shadow'
window.customElements.define('samora-sam-select-list', wrap(Vue, SamSelectList))

import SamSidebar from '~root/src/components/SectionComponents/SamSidebar/SamSidebar.vue?shadow'
window.customElements.define('samora-sam-sidebar', wrap(Vue, SamSidebar))

import SamSidebarManager from '~root/src/components/SectionComponents/SamSidebarManager/SamSidebarManager.vue?shadow'
window.customElements.define('samora-sam-sidebar-manager', wrap(Vue, SamSidebarManager))

import SamStepper from '~root/src/components/SectionComponents/SamStepper/SamStepper.vue?shadow'
window.customElements.define('samora-sam-stepper', wrap(Vue, SamStepper))

import SamTable from '~root/src/components/SectionComponents/SamTable/SamTable.vue?shadow'
window.customElements.define('samora-sam-table', wrap(Vue, SamTable))

import SamTabs from '~root/src/components/SectionComponents/SamTabs/SamTabs.vue?shadow'
window.customElements.define('samora-sam-tabs', wrap(Vue, SamTabs))

import SamTextList from '~root/src/components/SectionComponents/SamTextList/SamTextList.vue?shadow'
window.customElements.define('samora-sam-text-list', wrap(Vue, SamTextList))

import SamTextListItem from '~root/src/components/SectionComponents/SamTextList/SamTextListItem.vue?shadow'
window.customElements.define('samora-sam-text-list-item', wrap(Vue, SamTextListItem))

import SamTextarea from '~root/src/components/SectionComponents/SamTextarea/SamTextarea.vue?shadow'
window.customElements.define('samora-sam-textarea', wrap(Vue, SamTextarea))

import SamTimeAmountInput from '~root/src/components/SectionComponents/SamTimeAmountInput/SamTimeAmountInput.vue?shadow'
window.customElements.define('samora-sam-time-amount-input', wrap(Vue, SamTimeAmountInput))

import SamToggle from '~root/src/components/SectionComponents/SamToggle/SamToggle.vue?shadow'
window.customElements.define('samora-sam-toggle', wrap(Vue, SamToggle))

import SamTooltip from '~root/src/components/SectionComponents/SamTooltip/SamTooltip.vue?shadow'
window.customElements.define('samora-sam-tooltip', wrap(Vue, SamTooltip))